export const BOOTSTRAP = '@PROJECT_NAME/BOOTSTRAP';
export const BOOTSTRAP_SUCCESS = '@PROJECT_NAME/BOOTSTRAP_SUCCESS';
export const BOOTSTRAP_FAIL = '@PROJECT_NAME/BOOTSTRAP_FAIL';

export const SET_DARK_MODE = '@PROJECT_NAME/SET_DARK_MODE';
